module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media"
  }, [(!_vm.rightAlign) ? _c('div', {
    class: ['d-flex', 'mr-3', _vm.verticalAlignClass]
  }, [_vm._t("aside")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.rightAlign) ? _c('div', {
    class: ['d-flex', 'ml-3', _vm.verticalAlignClass]
  }, [_vm._t("aside")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe03dfd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/media.vue
// module id = 267
// module chunks = 0